import { render, staticRenderFns } from "./mecanismo-comunicacion.vue?vue&type=template&id=756080e4&"
import script from "./mecanismo-comunicacion.vue?vue&type=script&lang=js&"
export * from "./mecanismo-comunicacion.vue?vue&type=script&lang=js&"
import style0 from "./mecanismo-comunicacion.vue?vue&type=style&index=0&id=756080e4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports